import { render, staticRenderFns } from "./PaymentsDetails.vue?vue&type=template&id=5de6c511"
import script from "./PaymentsDetails.vue?vue&type=script&lang=js"
export * from "./PaymentsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports